import { createContext } from 'react';
import type { AuthUser } from './schemas/user';

export type AuthStatus = 'loading' | 'guest' | 'must_change' | 'authed';

export interface AuthState {
  status: AuthStatus;
  accessToken: string | null;
  user: AuthUser | null;
}

export interface AuthContextValue extends AuthState {
  login: (email: string, password: string) => Promise<void>;
  logout: () => Promise<void>;
  changePassword: (currentPassword: string, newPassword: string) => Promise<void>;
  refreshAccess: () => Promise<string | null>;
}

export const AuthContext = createContext<AuthContextValue | null>(null);
